import LocalReferencesView from "./LocalReferencesView";

export default LocalReferencesView;